/* global Blockly */

import React from 'react';
import MobiControlCore from './MobiControlCore';
import util from '../../../../../../utils/es5Utils'
import { markBlockAsDeprecated } from '../../helpers';

function defineBlock(context) {
    let prop = {...context};
    prop.tooltipText = "Get iOS device details value by specified key from MobiControl.";
    prop.responseText = "device details value";
    prop.responseBlockType = "text_response";
    let blockInstance = MobiControlCore(prop);

    
    const coreInit = blockInstance.init;
    blockInstance.init = function() {
        markBlockAsDeprecated(this);
        coreInit.call(this);
    };

    // override default fields
    blockInstance.addFields = function() {
        this.appendValueInput("VALUE")
            .appendField("get iOS device details by key")
            .setCheck("String");
    }
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            let value = util.parseString(Blockly.JavaScript.valueToCode(block, "VALUE", Blockly.JavaScript.ORDER_NONE));
            return `Snap.mcDeviceDetails.getIOSDeviceDetails('${value}', ${coreResponseCode});\n`;
        }
    }
}

const MobiControlGetIosDeviceDetails = function (props) {
    const name = 'snap_mobicontrol_getiosdevicedetails';
    MobiControlGetIosDeviceDetails.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return  <block type={name}>
                <value name="VALUE">
                    <shadow type="text"></shadow>
                </value>
            </block>;
}

export default MobiControlGetIosDeviceDetails;